import { render, staticRenderFns } from "./rightProtection.vue?vue&type=template&id=49ccf12a&scoped=true"
import script from "./rightProtection.vue?vue&type=script&lang=js"
export * from "./rightProtection.vue?vue&type=script&lang=js"
import style0 from "./rightProtection.vue?vue&type=style&index=0&id=49ccf12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ccf12a",
  null
  
)

export default component.exports